/* original source: https://ui.shadcn.com/docs/components/sonner */
'use client'

import { SpinnerIcon } from './SpinningLoader'
import { useTheme } from './ThemeProvider'
import {
  CircleCheckIcon,
  TriangleAlertIcon,
  InfoIcon,
  CircleXIcon,
} from 'lucide-react'
import { Toaster as Sonner, toast as sonnerToast } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

export function Toaster({ ...props }: ToasterProps) {
  const { theme } = useTheme()

  return (
    <Sonner
      theme={theme}
      // Sonner's stylesheet targets `.toaster`; it is not a Tailwind utility.
      className="toaster group !pointer-events-auto"
      expand
      icons={{
        error: <CircleXIcon className="text-red-600 dark:text-red-400" />,
        info: <InfoIcon className="text-blue-600 dark:text-blue-400" />,
        loading: <SpinnerIcon className="size-full" />,
        success: (
          <CircleCheckIcon className="text-green-600 dark:text-green-400" />
        ),
        warning: <TriangleAlertIcon className="text-tremor-brand" />,
      }}
      toastOptions={{
        classNames: {
          actionButton:
            'group-[.toast]:bg-tremor-background group-[.toast]:text-tremor-content-strong',
          cancelButton:
            'group-[.toast]:bg-tremor-background-muted group-[.toast]:text-tremor-content',
          content: 'flex-[1_0_0]',
          description: 'group-[.toast]:text-tremor-content',
          error:
            'group-[.toaster]:bg-red-50 group-[.toaster]:border-red-200 group-[.toaster]:text-red-800 dark:group-[.toaster]:bg-red-900/30 dark:group-[.toaster]:border-red-800 dark:group-[.toaster]:text-red-400',
          icon: 'size-5!',
          loader: 'size-full',
          loading: 'group-[.toaster]:text-tremor-content',
          toast:
            'group toast font-sans group-[.toaster]:bg-tremor-background group-[.toaster]:text-tremor-content-strong group-[.toaster]:border-tremor-border group-[.toaster]:shadow-lg',
        },
      }}
      {...props}
    />
  )
}

export const toast: typeof sonnerToast = sonnerToast
